import React, { useRef, useState } from 'react';
import styles from './index.module.scss';
import { Input, Popover } from 'antd';
import Icon from 'component/Icon';

import { useDispatch, useSelector } from 'react-redux';
import { searchContactList, setSearchList } from 'model/contact';
import { ContactV2, Person } from 'type/contact';
import { RootState } from 'model';
import PersonList from 'component/PersonList';
import { CONTACT_TYPE } from 'constant/contact';
import tracker from 'lib/tracker';

interface IProps {
  showPopover?: boolean;
  showList?: boolean;
  selectPerson?: Person[];
  disabledList?: Person[];
  checkedClick?: (person: Person) => void;
  unCheckedClick?: (person: Person) => void;
  search?: (keyword: string) => void;
  change?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setShowPopover?: (show: boolean) => void;
}

const SearchContact: React.FunctionComponent<IProps> = ({
  showPopover = false,
  showList = false,
  selectPerson,
  disabledList,
  checkedClick,
  unCheckedClick,
  search,
  change,
  setShowPopover
}) => {
  const [showSearch, setShowSearch] = useState(false);

  const searchHasMore: boolean = useSelector((state: RootState) => state.contact.searchHasMore);
  const [displayContacts, setDisplayContacts] = useState<ContactV2>();

  const dispatch = useDispatch();
  const searchRef = useRef<Input>(null);

  const onSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const keyword = (e.target as HTMLInputElement).value;
    if (keyword) {
      dispatch(
        searchContactList({
          keyword,
          callback: (data) => {
            setDisplayContacts(data);
          }
        })
      );
    }
    setShowSearch(true);
    search && search(keyword);
    setShowPopover && setShowPopover(true);

    // 埋点
    keyword && tracker?.reporteContactOperation('搜索联系人');
    // keyword && fridayAgent.pushData({ ...FRIDAYAGENT_EVENTS.WEB_TEAMS_CLICK_CONTACT_SEARCH, data: { contact_keyword: keyword } });
  };

  const unShowSearch = () => {
    setShowSearch(false);
    dispatch(setSearchList({ contactPersons: [], searchId: '', userId: '' }));
  };

  const searchOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      unShowSearch();
    }
    change && change(e);
  };

  const onScroll = (e: React.UIEvent<HTMLDivElement>) => {
    if (!searchHasMore) return;
    // 滑动到底部加载更多
    if (e.currentTarget.scrollHeight - e.currentTarget.clientHeight <= e.currentTarget.scrollTop) {
      dispatch(
        searchContactList({
          keyword: searchRef.current?.state.value,
          callback: (data) => {
            setDisplayContacts(data);
          }
        })
      );
    }
  };

  return (
    <div className={styles.wrapper} onClick={(e) => e.stopPropagation()}>
      <Popover
        content={
          <div className={styles.popoverPerson}>
            <PersonList
              personList={displayContacts?.memberDetailResponseList || []}
              className={styles.popoverList}
              onScroll={onScroll}
              noPersonText="未搜索到结果"
              type={CONTACT_TYPE.SEARCH}
              contactCard
              setShowPopover={() => setShowPopover && setShowPopover(false)}
            />
          </div>
        }
        visible={showPopover && showSearch}
        placement="bottom"
        trigger="click"
        overlayClassName={styles.popover}
      >
        <Input
          placeholder="搜索手机号/邮箱/用户名"
          allowClear
          prefix={<Icon type="iconhome_search_ic" size={16} />}
          onPressEnter={onSearch}
          onChange={searchOnChange}
          ref={searchRef}
        />
      </Popover>

      {showList && (
        <>
          <PersonList
            className={styles.searchList}
            selectPerson={selectPerson}
            personList={displayContacts?.memberDetailResponseList || []}
            disablePerson={disabledList}
            checkbox
            checkedClick={checkedClick}
            unCheckedClick={unCheckedClick}
            noPersonText="未搜索到结果"
            onScroll={onScroll}
            type={CONTACT_TYPE.SEARCH}
          />
        </>
      )}
    </div>
  );
};

export default SearchContact;
